import { ReactQueryV5 } from "@mindlercare/mindlerapi-client";
const { useQuery } = ReactQueryV5;
import { httpClient } from "../../services/httpClient";
import { Document } from "@contentful/rich-text-types";
import type { ContentfulRichContentLinks } from "@mindlercare/icbt";
import { hoursToMilliseconds } from "date-fns";

export const useGetProgramContentQuery = ({
  programId,
  languageCode,
}: {
  programId?: string;
  languageCode?: string;
}) =>
  useQuery({
    queryKey: ["program", programId, languageCode],
    queryFn: async () => {
      const { data } = await httpClient.get<ProgramWithContent>(
        `indianapolis/program/${programId}`,
        {
          params: {
            languageCode,
          },
        },
      );

      return data;
    },
    enabled: !!programId,
    staleTime: hoursToMilliseconds(12),
  });

type IcbtPage = {
  id: string;
  title: string;
  type: "Page";
  content: {
    json: Document;
    links: ContentfulRichContentLinks;
  };
};

export type PageWithContent = IcbtPage;

export type ProgramWithContent = {
  title: string;
  pages: PageWithContent[];
  free: boolean;
};
